// removed by extract-text-webpack-plugin
module.exports = {"Tuple":"_f7rAB","ImageContainer":"_1Bg3z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Hotel/HotelTupleStacked/HotelTupleStacked.scss
// module id = 530
// module chunks = 0